/**
 * GERADO PELO CI — não editar à mão.
 * Ver .gitlab/scripts/gerar-build-info.sh e SENTRY.md.
 */
export const BUILD_INFO = {
  release: '0c491bbe',
  dist: 'production',
};
